import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { FilteredKeys } from '../../../Utility/Types';

//type Value = NonNullable<unknown>;

export default class AnyProperty<
    Value extends NonNullable<unknown>,
    TPlayerStateKey extends FilteredKeys<IPlayerState, Value>,
    TPlayerDataKey extends FilteredKeys<IPlayerData, Value>
> implements PlayerProperty<TPlayerStateKey, TPlayerDataKey> {
    protected readonly playerStateKey: TPlayerStateKey;
    protected readonly playerDataKey: TPlayerDataKey;
    protected readonly defaultValue: Value;

    constructor(playerStateKey: TPlayerStateKey, playerDataKey: TPlayerDataKey, defaultValue: Value) {
        this.playerStateKey = playerStateKey;
        this.playerDataKey = playerDataKey;
        this.defaultValue = defaultValue;
    }

    public isChanged(playerStateData: IPlayerState, playerEndpointData: IPlayerData): boolean {
        // @ts-ignore
        const endpointValue = this.restore(playerEndpointData);

        return endpointValue !== playerStateData[this.playerStateKey];
    }

    public restore(playerEndpointData: IPlayerData): Restore<TPlayerStateKey> {
        // @ts-ignore
        return playerEndpointData[this.playerDataKey] ?? this.defaultValue;
    }

    public save(playerStateData: IPlayerState): Save<TPlayerDataKey> {
        // @ts-ignore
        return { [this.playerDataKey]: playerStateData[this.playerStateKey] } as Pick<IPlayerData, TPlayerDataKey>;
    }
}
